import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';

import { HomeService } from '@pages/home/services/home.service';

@Component({
    imports: [],
    selector: 'app-office-logo',
    templateUrl: 'office-logo.component.html',
    styleUrls: ['office-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfficeLogoComponent implements OnInit {
  public image$ = signal(null);
  public showImageNow$ = signal(false);
  public portalName$ = signal('');
  public logoUrl$ = signal('');

  private pRCO: number;

  private homeService = inject(HomeService);

  ngOnInit(): void {
    this.getUserContext();
  }

  private getUserContext(): void {
    this.homeService.getUserContext().then(response => {
      this.pRCO = response.PRCo;

      this.checkCompanyLogo();
      this.getPortalName();
    });
  }

  private getPortalName(): void {
    this.homeService.getPortalName(this.pRCO).then(response => {
      this.portalName$.set(response ?? null);
    });
  }

  private checkCompanyLogo(): void {
    this.homeService.getCompanyLogo(this.pRCO, 's').then(response => {
      this.image$.set(response ?? null);
      this.showImageNow$.set(true);
      this.logoUrl$.set('/Company/GetLogo?co=' + this.pRCO + '&size=S');
    });
  }
}
